import { useEffect, useRef, useState } from "react"
import {
  aBannerVisible,
  aIsPipMode,
  aIsPlaying,
  useAtomValue,
  useSetAtom,
} from "~/atoms"
import { cn } from "~/utils"
import { PictureOutIcon } from "../icons"
import { ControlButton } from "./control-button"

export default function PipModeControl({ className }: { className?: string }) {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)
  const setIsPipMode = useSetAtom(aIsPipMode)
  const [isPipEnabled, setIsPipEnabled] = useState(false)
  const setIsPlaying = useSetAtom(aIsPlaying)
  const bannerVisible = useAtomValue(aBannerVisible)

  useEffect(() => {
    if (document.pictureInPictureEnabled) {
      setIsPipEnabled(true)
    }
    const enterPictureInPicture = () => {
      setIsPipMode(true)
      if (intervalRef.current) {
        clearInterval(intervalRef.current || undefined)
      }
      intervalRef.current = setInterval(() => {
        if (!document.pictureInPictureElement) {
          setIsPipMode(false)
          setIsPlaying(false)
          clearInterval(intervalRef.current || undefined)
        }
      }, 500)
    }
    const leavePictureInPicture = () => {
      setIsPipMode(false)
      setIsPlaying(false)
      clearInterval(intervalRef.current || undefined)
    }
    document.addEventListener("enterpictureinpicture", enterPictureInPicture)
    document.addEventListener("leavepictureinpicture", leavePictureInPicture)

    return () => {
      document.removeEventListener(
        "enterpictureinpicture",
        enterPictureInPicture
      )
      document.removeEventListener(
        "leavepictureinpicture",
        leavePictureInPicture
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isPipEnabled || bannerVisible) {
    return null
  }

  return (
    <ControlButton
      className={cn("px-1 py-0 sm:px-1 sm:py-0", className)}
      onClick={() => {
        const video = document.getElementsByTagName("video")[0]
        video.requestPictureInPicture()
      }}
    >
      <PictureOutIcon className="h-5 w-5 text-white sm:h-6 sm:w-6" />
    </ControlButton>
  )
}
